<template>
    <div class="pageWidth joinInfo">
        <div class="join fix mt36" v-if="!showFri&&coopList.length>0"> <strong class="title fmE">合作媒体<span>•</span>机构</strong>

            <ul class="comp_list20 oh lih" v-if="coopList.length">
                <li v-for="(item,i) in coopList" :key="i">
                    <a target="_blank" :key="i" :href="item.link">{{item.title}}</a>
                </li>
            </ul>
        </div>
        <!-- <p class="oh contact" v-if="!orgEdit"><span>责任编辑：王蕊</span><span class="tel">15097761852</span><a href="mailto:wangrui@artron.net" class="mail">wangrui@artron.net</a></p> -->
        <p class="oh contact" ></p>
    </div>
</template>

<script>
import {getOther} from "@/api/index";

export default {
    name: "contact",
    props:['showFri','orgEdit'],
    data(){
        return{
            coopList:[]
        }
    },
    mounted() {
        this.getOther()
    },
    methods:{
        getOther(){
            getOther().then((res) => {
                let data = res.data;
                this.coopList = data.coop
            });
        },
    }
}
</script>

<style scoped>
.contact{border-top: 0;}
</style>